import type {ZodType} from "zod";
import {z as zod} from "zod";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type PlatformAccessMatrix = Record<Uuid, Record<Uuid, boolean>>;

export const platformAccessMatrixValidator: ZodType<PlatformAccessMatrix> = zod.record(
    uuidZodValidator,
    zod.record(uuidZodValidator, zod.boolean()),
);
